// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".IconPlaceholder-placeholder-3tnXb {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: calc(var(--fi-size, 1.1em) / -5);\n  height: 1em;\n  width: var(--fi-size, 1.1em);\n}\n", ""]);
// Exports
exports.locals = {
	"placeholder": "IconPlaceholder-placeholder-3tnXb"
};
module.exports = exports;
